import {EditorClipboardMutation, EditorClipboardPayloadByMutationMap} from '../../modules/editor/Clipboard';
import {CoreGraphNodeId} from '../../../../../@polygonjs/polygonjs/src/core/graph/CoreGraph';
import {Ref, ref} from 'vue';

export class EditorClipboardStoreControllerClass {
	private static _instance: EditorClipboardStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorClipboardStoreControllerClass());
	}

	private constructor() {}

	private _node_id: Ref<CoreGraphNodeId | null> = ref(null);
	private readonly _param_id: Ref<CoreGraphNodeId | null> = ref(null);
	private readonly _upload_name: Ref<string | null> = ref('');

	node_id(): CoreGraphNodeId | null {
		return this._node_id.value;
	}
	param_id(): CoreGraphNodeId | null {
		return this._param_id.value;
	}
	upload_name(): string | null {
		return this._upload_name.value;
	}

	// mutations
	set_node_id(node_id: EditorClipboardPayloadByMutationMap[EditorClipboardMutation.NODE_ID]): void {
		this._node_id.value = node_id;
	}
	set_param_id(param_id: EditorClipboardPayloadByMutationMap[EditorClipboardMutation.PARAM_ID]): void {
		this._param_id.value = param_id;
	}
	set_upload_name(upload_name: EditorClipboardPayloadByMutationMap[EditorClipboardMutation.UPLOAD_NAME]): void {
		this._upload_name.value = upload_name;
	}
}

export const EditorClipboardStoreController = EditorClipboardStoreControllerClass.instance();
